import {createNamespace} from "src/util/create";
import cls from "classnames";
import {Layout, Title, Description, Button} from "./styles";
import React from "react";


const [bem] = createNamespace('coin-card');

export interface GiftCardProps {
    amount: number;
    onClick: () => void
}
function GiftCard(props: GiftCardProps) {

    const {
        amount,
        onClick,
    } = props;
    return <Layout className={cls(bem())}>
        <Title>获得<em>{amount * 2}</em>元</Title>
        <Description>充值{amount}元100%返利</Description>
        <Button onClick={() => {
            onClick()
        }}>
            充值领取
        </Button>
    </Layout>
}

export default GiftCard;